import { AppState, FeedPageChicagoAppState } from '../../../initialStateRegistration';
import { FeedPageChicagoMinorSections, FeedPageSectionNames, FeedPageChicagoTopSection } from './feedPageChicago.initialState';

export const getFeedPage = (state: AppState) => (state as FeedPageChicagoAppState).template;

export const getSectionDataByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key];

export const getSectionArticlesByKey = (key: FeedPageChicagoMinorSections) => (state: AppState) => getFeedPage(state)[key].articles;

export const getSectionTitleByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].sectionTitle;

export const getShowMorePaginationTextByKey = (key: FeedPageChicagoMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationText;

export const getShowMorePaginationURLByKey = (key: FeedPageChicagoMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationURL;

export const getSectionSubtitle = (key: FeedPageChicagoTopSection) => (state: AppState) => getFeedPage(state)[key].sectionSubtitle;

export const getSectionImage = (key: FeedPageChicagoTopSection) => (state: AppState) => getFeedPage(state)[key].image;

export const getPagination = (state: AppState) => getFeedPage(state).pagination;

export const getMetadataDescription = (state: AppState) => getFeedPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getFeedPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getFeedPage(state).metadataImage;

export const getHreflangData = (state: AppState) => getFeedPage(state).hreflangData;
